query GetQueuedEmailsForEntity($entityId: ID!) {
    coreEntity(id: $entityId) {
        id
        queuedEmails {
            id
            messageNumber
            subject
            deliveryTime
            isNextScheduledEmail
            to {
                ... on NutEmailAddress {
                    avatarEntity {
                        id
                        name
                        htmlUrl
                    }
                }
            }
            emailSequence {
                id
                messageCount
                emailSequenceTemplate {
                    id
                    name
                }
            }
        }
    }
}
